<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <!-- 添加发货申请徽章 -->
          <template v-if="onlyOneChild.route == 'shipmentRequest' && shipmentCount > 0">
            <el-badge :value="shipmentCount" class="item-badge" />
          </template>
          <template v-if="item.route == 'outEntrepot' && entrepotCount > 0">
          <el-badge :value="entrepotCount" class="item-badge" />
        </template>
          <item :count="shipmentCount +entrepotCount" :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <!-- <item v-if="item.icon" :icon="item.icon" :title="item.name"/> -->
        <!-- 添加发货申请徽章 -->
        <template v-if="item.route == 'shipmentRequest' && shipmentCount > 0">
          <el-badge :value="shipmentCount" class="item-badge" />
        </template>
        <template v-if="item.route == 'outEntrepot' && entrepotCount > 0">
          <el-badge :value="entrepotCount" class="item-badge" />
        </template>
        <item :count="shipmentCount +entrepotCount" :route="item.route" v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {
    }
  },
  
  created() {
    
  },
  computed: {
    ...mapGetters(['shipmentCount', 'entrepotCount'])
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    
  }
}
</script>
<style lang="less" scoped>
/* 修改徽章定位为右上角 */
::v-deep .item-badge {
  position: absolute;
  top: 0px;
  left: 14px;
  background-color: #ff4949;
  border-radius: 50%;
  line-height: 14px;  
  text-align: center; 
  font-size: 10px;    
}
</style>
